import React from 'react';
import {createBrowserRouter, Outlet, RouterProvider} from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ProductOverview from './pages/ProductOverview';
import RefundPolicy from './pages/RefundPolicy';
import Features from './pages/Features';
import About from './pages/About';
import Security from './pages/Security';
import ScrollToTop from './components/ScrollToTop';
import PrivacyAndTerms from "./pages/PrivacyAndTerms.jsx";

const HomePage = () => (
  <div className="bg-linear-to-b from-gray-900 to-gray-800">
    <HeroSection />
    <FeaturesSection />
    <HowItWorksSection />
    <BenefitsSection />
    <TestimonialsSection />
    <CTASection />
  </div>
);

const Layout = () => (
    <>
        <ScrollToTop />
        <div className="min-h-screen overflow-x-hidden max-w-[100vw]">
            <Navbar />
            <Outlet />
            <Footer />
        </div>
    </>
);

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            { path: '/', element: <HomePage /> },
            { path: '/features', element: <Features /> },
            { path: '/product-overview', element: <ProductOverview /> },
            { path: '/refund-policy', element: <RefundPolicy /> },
            { path: '/privacy-and-terms', element: <PrivacyAndTerms /> },
            { path: '/about', element: <About /> },
            { path: '/security', element: <Security /> },
        ],
    },
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
